import { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { ArrowRight } from "lucide-react";
import { REGISTRATION_URL } from "../lib/config";

export const StickyCTA = () => {
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    const onScroll = () => {
      const past = window.scrollY > window.innerHeight * 0.9;
      const nearEnd = window.innerHeight + window.scrollY > document.body.scrollHeight - 500;
      setVisible(past && !nearEnd);
    };
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <AnimatePresence>
      {visible && (
        <motion.div
          initial={{ y: 90 }}
          animate={{ y: 0 }}
          exit={{ y: 90 }}
          transition={{ duration: 0.45, ease: [0.16, 1, 0.3, 1] }}
          className="fixed inset-x-0 bottom-0 z-50 px-4 pb-4 md:hidden"
          data-testid="sticky-mobile-cta"
        >
          <a
            href={REGISTRATION_URL}
            data-testid="sticky-cta-button"
            className="flex items-center justify-center gap-3 bg-gold py-4 font-display text-sm font-bold uppercase tracking-[0.18em] text-night shadow-[0_-8px_40px_rgba(0,0,0,0.6)]"
          >
            Inizia gratis
            <ArrowRight className="h-4 w-4" strokeWidth={2.5} />
          </a>
        </motion.div>
      )}
    </AnimatePresence>
  );
};
